import { useEffect } from 'react';
import {
  THEMEABLE_COMPONENTS,
  useLandaTheme,
} from 'stores/LandaTheme/landaTheme';

const useDebtDarkMode = () => {
  const { setThemes } = useLandaTheme();

  useEffect(() => {
    setThemes(
      [
        THEMEABLE_COMPONENTS.NAV_BAR,
        THEMEABLE_COMPONENTS.DRAWER,
        THEMEABLE_COMPONENTS.FOOTER,
      ],
      'dark'
    );
    document.documentElement.style.backgroundColor = 'black';
    return () => {
      setThemes(
        [
          THEMEABLE_COMPONENTS.NAV_BAR,
          THEMEABLE_COMPONENTS.DRAWER,
          THEMEABLE_COMPONENTS.FOOTER,
        ],
        'light'
      );
      document.documentElement.style.backgroundColor = 'white';
    };
  }, []);
};

export default useDebtDarkMode;
